export * from './IconTechResponse';
